if (!customElements.get('ales-navigation')) {
  class AlesNavigation extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.dialog = this.querySelector('[data-ales-navigation-dialog]');
      this.openButton = this.querySelector('[data-ales-navigation-open]');
      this.closeButton = this.querySelector('[data-ales-navigation-close]');
      if (!this.dialog || !this.openButton || !this.closeButton) return;

      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };

      this.openButton.addEventListener('click', () => this.open(), options);
      this.closeButton.addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener(
        'cancel',
        (event) => {
          event.preventDefault();
          this.close();
        },
        options
      );
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      }, options);
      this.dialog.querySelectorAll('a[href]').forEach((link) => {
        link.addEventListener('click', () => this.close(true), options);
      });
      this.dialog.querySelectorAll('[data-ales-navigation-disclosure]').forEach((disclosure) => {
        disclosure.addEventListener('toggle', () => {
          if (!disclosure.open) return;
          this.dialog.querySelectorAll('[data-ales-navigation-disclosure][open]').forEach((other) => {
            if (other !== disclosure) other.removeAttribute('open');
          });
        }, options);
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      document.documentElement.classList.remove('ales-navigation-open');
    }

    open() {
      if (this.dialog.open || this.isClosing) return;

      this.dialog.showModal();
      document.documentElement.classList.add('ales-navigation-open');
      this.openButton.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => this.dialog.classList.add('is-open'));
    }

    close(immediate = false) {
      if (!this.dialog.open || this.isClosing) return;

      this.isClosing = true;
      this.dialog.classList.remove('is-open');
      this.openButton.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ales-navigation-open');

      const finish = () => {
        if (this.dialog.open) this.dialog.close();
        this.isClosing = false;
        if (!immediate) this.openButton.focus({ preventScroll: true });
      };

      if (immediate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finish();
        return;
      }

      window.setTimeout(finish, 520);
    }
  }

  customElements.define('ales-navigation', AlesNavigation);
}
